import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './leadetshipetstrategie.css';
import { useNavigate } from 'react-router-dom';

const trainings = [
  {
    id: 'strategic-management',
    title: 'Management Stratégique de l’Entreprise',
    details: [
      {
        detail: 'Description',
        description:
          'Le management stratégique permet à l’entreprise de créer des avantages compétitifs durables.',
      },
      {
        detail: 'Objectives',
        description: (
          <ul>
            <li>Connaitre les enjeux et maitriser les principes de la réflexion stratégique</li>
            <li>Comprendre la démarche et les composantes du management stratégique de l’entreprise</li>
            <li>Être en mesure de formuler et de mettre en œuvre des recommandations stratégiques à même de créer des avantages compétitifs durables.</li>
          </ul>
        ),
      },
    ],
  },
];

const LeadershipEtStrategie = () => {
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate(); // ✅ correct place

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  return (
    <div className="min-vh-100">
      <Header />

      <div className="card-container">
        <h1 className="catalog-title">Formations - Leadership et Stratégie</h1>

        <div className="container">
          {!showDetails ? (
            // 👉 CARD VIEW
            <div className="card mx-auto shadow card-centered text-center">
              <div className="card-body">
                <h2 className="card-title mb-3">
                  Management Stratégique de l’Entreprise
                </h2>

                <button
                  onClick={handleShowDetails}
                  className="btn btn-primary"
                >
                  En savoir plus
                </button>
              </div>
            </div>
          ) : (
            // 👉 DETAILS VIEW
            <div className="container mt-5">
              <h2>{trainings[0].title}</h2>

              <table className="details-table">
                <thead>
                  <tr>
                    <th>Detail</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {trainings[0].details.map((detail, index) => (
                    <tr key={index}>
                      <td>{detail.detail}</td>
                      <td>{detail.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* ✅ PARTICIPATE BUTTON */}
              <div className="text-center mt-4">
                <button
                  className="btn btn-success"
                  onClick={() =>
                    navigate('/contact', {
                      state: { training: trainings[0].title },
                    })
                  }
                >
                  Participer
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LeadershipEtStrategie;